import { FeedbackTypesCodeMap } from '../Cases/constants/CasesConstants';
import { Tag } from '@navi/web-ui/lib/primitives';
import { formatAmount, getRiskBarColor } from 'src/utils/commonUtils';
import { AgentTypes } from './interface';
import styles from './TeamLead.module.scss';
import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { CaseStatus } from '../CaseDetails/interfaces/CaseDetail.type';

export const TEAM_LEAD_COLUMN_DEFS_NAVI_TABLE: NaviTableColumnDef<any, any>[] = [
  {
    accessorKey: 'riskSegment',
    header: '',
    cell: info => {
      const barColor = getRiskBarColor(info?.row?.original?.riskSegment);
      const isSnoozed = info?.row?.original?.status === CaseStatus.ON_HOLD;
      return (
        <div className={'w-2 h-full'} style={{ backgroundColor: !isSnoozed ? barColor : '' }} />
      );
    },
    cellStyle: {
      padding: 0
    },
    size: 20
  },
  {
    accessorKey: 'customerName',
    header: 'Customer Name',
    size: 180,
    tooltip: true
  },
  {
    accessorKey: 'accountNumber',
    header: 'LAN',
    size: 180
  },
  {
    accessorKey: 'unpaidDays',
    header: 'DPD',
    enableSorting: true,
    size: 140
  },
  {
    accessorKey: 'outStandingAmount',
    header: 'Outstanding Amount',
    enableSorting: true,
    size: 180,
    cell: info => {
      const value = formatAmount(info.row.original.outStandingAmount ?? 0);
      return value;
    }
  },
  {
    accessorKey: 'agentName',
    header: 'Agent Name',
    size: 200,
    tooltip: true
  },
  {
    accessorKey: 'agentPhoneNumber',
    header: 'Agent Number',
    size: 145
  },
  {
    accessorKey: 'agentType',
    header: 'Agent Type',
    size: 150,
    cell: info => {
      const agentType = info.row.original?.agentType as keyof typeof AgentTypes;
      return agentType;
    }
  },
  {
    accessorKey: 'agencyName',
    header: 'Agency Name',
    size: 160,
    tooltip: true
  },
  {
    accessorKey: 'feedbackType',
    header: 'Last feedback',
    size: 300,
    cell: info => {
      const feedbackType: string = info.row.original.feedbackType;
      const { color = 'green', label } = FeedbackTypesCodeMap[feedbackType] || {};
      if (!label || !color) return null;
      return (
        <Tag
          color={color}
          variant="transparent"
          label={label}
          labelClass={styles.lastFeedbackLabel}
        />
      );
    }
  }
];
